/**
 * Logos crypto en SVG INLINE (USDC, Solana). Inline = pas de fetch externe →
 * conforme à la CSP stricte du cockpit (aucun `img-src` GitHub/CDN crypto).
 * Utilisés dans l'onboarding membre (écran « Finalise ton compte ») pour rendre
 * l'étape wallet lisible : « adresse USDC sur Solana ».
 */

interface LogoProps {
  className?: string;
}

/** Pièce USDC — cercle bleu Circle (#2775CA) + anneau blanc + « $ ». */
export function UsdcLogo({ className }: LogoProps) {
  return (
    <svg
      viewBox="0 0 32 32"
      className={className}
      role="img"
      aria-label="USDC"
    >
      <circle cx="16" cy="16" r="15" fill="#2775CA" />
      <circle
        cx="16"
        cy="16"
        r="11"
        fill="none"
        stroke="#ffffff"
        strokeWidth="1.6"
      />
      <text
        x="16"
        y="21"
        textAnchor="middle"
        fontSize="15"
        fontWeight="700"
        fill="#ffffff"
        fontFamily="Arial, Helvetica, sans-serif"
      >
        $
      </text>
    </svg>
  );
}

/** Marque Solana — 3 barres chevron, dégradé violet → vert. */
export function SolanaLogo({ className }: LogoProps) {
  return (
    <svg
      viewBox="0 0 397.7 311.7"
      className={className}
      role="img"
      aria-label="Solana"
    >
      <defs>
        <linearGradient id="dozka-sol-grad" x1="360" y1="-37" x2="141" y2="383" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#9945FF" />
          <stop offset="1" stopColor="#14F195" />
        </linearGradient>
      </defs>
      <g fill="url(#dozka-sol-grad)">
        <path d="M64.6 237.9c2.4-2.4 5.7-3.8 9.2-3.8h317.4c5.8 0 8.7 7 4.6 11.1l-62.7 62.7c-2.4 2.4-5.7 3.8-9.2 3.8H6.5c-5.8 0-8.7-7-4.6-11.1l62.7-62.7z" />
        <path d="M64.6 3.8C67.1 1.4 70.4 0 73.8 0h317.4c5.8 0 8.7 7 4.6 11.1l-62.7 62.7c-2.4 2.4-5.7 3.8-9.2 3.8H6.5c-5.8 0-8.7-7-4.6-11.1L64.6 3.8z" />
        <path d="M333.1 120.1c-2.4-2.4-5.7-3.8-9.2-3.8H6.5c-5.8 0-8.7 7-4.6 11.1l62.7 62.7c2.4 2.4 5.7 3.8 9.2 3.8h317.4c5.8 0 8.7-7 4.6-11.1l-62.7-62.7z" />
      </g>
    </svg>
  );
}
